import {Code as MantineCode} from '@mantine/core';

/**
 * Inline/block code text — design-layer pass-through over Mantine `Code`.
 * @registry Pass-through Mantine Code; import this instead of @mantine/core outside src/design.
 */
export const Code = MantineCode;
